import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import styled, { withTheme } from 'styled-components';
import { filter, includes, map, get } from 'lodash';

import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Table from 'components/Table';
import Header from 'components/Table/Header';
import Cell from 'components/Cell';
import ExportButton from 'components/Export';
import Spinner from 'components/Spinner';
import FilterBloc from '../WxrExpertsRatingsFilters';

const ExpertsRatingsContainer = styled.div`
  position: relative;
  display: grid;

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .ReactTable {
    border: none;
  }

  .infos {
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    font-weight: normal;
    font-style: italic;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${(props) => props.theme.colors['dark']};
    margin-top: 10px;
  }

  .rightComponentsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;

    > div:not(:last-child) {
      margin-right: 10px;
    }
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    max-width: 100vw;
    .tableWxrContainer {
      max-width: 100%;
    }
  }
`;

class ExpertsRatings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hoverExport: false,
      sorted: [],
      rank: null,
      loading: true,
      type: { label: 'Primeur', value: 'is_primeur' },
      vintage: { label: 2008, value: 2008 },
      color: null,
      appellation: null,
      listOfClientWines: []
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps !== this.props &&
      this.props.data !== prevProps.data &&
      this.props.data &&
      this.props.data.length > 0 &&
      !this.state.vintage
    ) {
      this.setState({
        vintage: {
          label: this.props.data[0].vintage,
          value: this.props.data[0].vintage
        }
      });
    }
  }

  handleSort(id) {
    let { sorted } = this.state;
    let desc = true;
    if (sorted.length > 0 && sorted[0].id === id) {
      desc = !sorted[0].desc;
    }
    sorted = [{ id, desc }];
    this.setState({ sorted });
  }

  handleRemove(id) {
    let { data } = this.state;
    data = data.filter((row) => row.id !== id);

    this.setState({ data });
  }

  isClientWine(value) {
    const { listOfClientWines } = this.state;
    return (
      filter(listOfClientWines, (item) => item.wine_name === value).length > 0
    );
  }

  hilightCell(isClientWine) {
    if (isClientWine) {
      return `background-color: ${this.props.theme.colors['terra-cotta']}; color: ${this.props.theme.colors['white']}`;
    } else {
      return '';
    }
  }

  getColumns() {
    return window.innerWidth > 845
      ? [
          {
            Header: () => (
              <Header
                sortable={true}
                sort={() => this.handleSort('wine')}
                styles={`justify-content:flex-start;padding-left:30px;.title{font-size:12px;}`}
                title={I18n.t('notes.wxr.columns.wine')}
              />
            ),
            Cell: (props) => (
              <Cell
                {...props}
                styles={`justify-content:flex-start;padding-left:30px;font-weight: 600; ${this.hilightCell(
                  props.original.isClientWine
                )}`}
              >
                {props.value}
              </Cell>
            ),
            minWidth: 250,

            accessor: 'wine'
          },
          {
            Header: () => (
              <Header
                title={I18n.t('notes.wxr.columns.wxr')}
                sortable={true}
                sort={() => this.handleSort('wxr')}
                styles={`.title{font-size:12px}`}
              />
            ),
            Cell: (props) => (
              <Cell
                type="rank"
                {...props}
                styles={this.hilightCell(props.original.isClientWine)}
              >
                {props.value}
              </Cell>
            ),

            sortMethod: (a, b) =>
              Number(a && a.rank ? a.rank : 0) -
              Number(b && b.rank ? b.rank : 0),
            accessor: 'wxr'
          },
          {
            Header: () => (
              <Header
                title={I18n.t('notes.wxr.columns.yxr')}
                sortable={true}
                sort={() => this.handleSort('yxr')}
                styles={`.title{font-size:12px}`}
              />
            ),
            Cell: (props) => (
              <Cell
                type="rank"
                {...props}
                styles={this.hilightCell(props.original.isClientWine)}
              >
                {props.value}
              </Cell>
            ),

            sortMethod: (a, b) =>
              Number(a && a.rank ? a.rank : 0) -
              Number(b && b.rank ? b.rank : 0),
            accessor: 'yxr'
          },
          {
            Header: () => (
              <Header
                title={I18n.t('notes.wxr.columns.diff')}
                sortable={true}
                sort={() => this.handleSort('gap')}
                styles={`.title{font-size:12px}`}
              />
            ),
            Cell: (props) => (
              <Cell
                type="evolution"
                {...props}
                styles={this.hilightCell(props.original.isClientWine)}
              />
            ),

            sortMethod: (a, b) =>
              Number(a && a.evol ? a.evol : 0) -
              Number(b && b.evol ? b.evol : 0),
            accessor: 'gap'
          }
        ]
      : [
          {
            Header: () => (
              <Header
                sortable={true}
                sort={() => this.handleSort('wine')}
                styles={`justify-content:flex-start;padding-left:30px;.title{font-size:12px;}`}
                title={I18n.t('notes.wxr.columns.wine')}
              />
            ),
            Cell: (props) => (
              <Cell
                {...props}
                styles={`justify-content:flex-start;padding-left:30px;font-weight: 600; ${this.hilightCell(
                  props.original.isClientWine
                )}`}
              >
                {props.value}
              </Cell>
            ),
            minWidth: 150,

            accessor: 'wine'
          },
          {
            Header: () => (
              <Header
                title={I18n.t('notes.wxr.columns.wxr')}
                sortable={true}
                sort={() => this.handleSort('wxr')}
                styles={`.title{font-size:12px}`}
              />
            ),
            Cell: (props) => (
              <Cell
                type="rank"
                {...props}
                styles={
                  props.original.isClientWine
                    ? 'background-color: rgb(226, 93, 52); color: white'
                    : ''
                }
              >
                {props.value}
              </Cell>
            ),

            sortMethod: (a, b) =>
              Number(a && a.rank ? a.rank : 0) -
              Number(b && b.rank ? b.rank : 0),
            accessor: 'wxr'
          }
        ];
  }

  formatData(data) {
    const { clientWines } = this.props;

    data = data.map((item) => {
      item.yxr_rank = Number(item.yxr_rank);

      item.yxr = Number(item.yxr);

      item.wxr_rank = Number(item.wxr_rank);

      item.wxr = Number(item.wxr);

      let evol = (item.yxr_rank.toFixed(0) - item.wxr_rank.toFixed(0)) * -1;
      let evolLabel = 'neutral';
      if (item.yxr_rank && item.wxr_rank) {
        evolLabel = evol > 0 ? 'positive' : evol < 0 ? 'negative' : 'neutral';
      }

      return {
        wine: item.wine_name,
        isClientWine:
          filter(clientWines, (client) => client.wine_name === item.wine_name)
            .length > 0,
        wxr: {
          value: item.wxr.toLocaleString('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }),
          rank: item.wxr_rank
        },
        yxr: {
          value: item.yxr.toLocaleString('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }),
          rank: item.yxr_rank
        },
        gap: {
          evolution: evolLabel,
          evol: evol,
          value: evol > 0 ? '+' + evol : evol < 0 ? evol : ''
        }
      };
    });
    if (this.state.loading) {
      this.setState({ loading: false });
    }
    return data;
  }

  filterData() {
    const data = this.props.data.data || [];
    let filteredData = [...data];
    const { vintage, color, appellation, rank } = this.state;
    filteredData = vintage
      ? filteredData.filter((item) => item.vintage === vintage.value)
      : filteredData.filter((item) =>
          includes(map(filteredData, 'vintage'), item.vintage)
        );
    filteredData = color
      ? filteredData.filter((item) => item.wine_color === color.value)
      : filteredData;
    filteredData = appellation
      ? filteredData.filter(
          (item) => item.wine_appellation === appellation.value
        )
      : filteredData;
    filteredData = rank
      ? filteredData.filter((item) => item.wine_classement === rank.value)
      : filteredData;
    return filteredData;
  }

  getExportName() {
    return `${
      get(this.state, 'type.label') ? get(this.state, 'type.label') + '-' : ''
    }${
      get(this.state, 'appellation.label')
        ? get(this.state, 'appellation.label') + '-'
        : ''
    }${
      get(this.state, 'rank.label') ? get(this.state, 'rank.label') + '-' : ''
    }${
      get(this.state, 'vintage.label')
        ? get(this.state, 'vintage.label') + '-'
        : ''
    }${
      get(this.state, 'wine.label') ? get(this.state, 'wine.label') + '-' : ''
    }`;
  }

  getOptions() {
    const data = this.props.data || {
      filters: { classements: [], appellations: [], vintages: [], colors: [] }
    };

    const typeOption = [
      {
        label: I18n.t('notes.wxr.typeOptions.isPrimeur'),
        value: 'is_primeur'
      },
      {
        label: I18n.t('notes.wxr.typeOptions.isLivrable'),
        value: 'is_livrable'
      }
    ];

    return {
      rank: data.filters.classements.map((item) => ({
        value: item,
        label: item
      })),
      appellation: data.filters.appellations.map((item) => ({
        value: item,
        label: item
      })),
      vintage: data.filters.vintages.map((item) => ({
        value: item,
        label: item
      })),
      color: data.filters.colors.map((item) => ({ value: item, label: item })),
      type: typeOption
    };
  }

  handleOnChangeFilter(param, value) {
    this.setState({ [param]: value }, () => {
      this.props.onChangeFilters({
        type: this.state.type.value,
        vintage: this.state.vintage.value
      });
    });
  }

  render() {
    const options = this.getOptions();
    const { sorted, vintage, type } = this.state;
    const columns = this.getColumns();
    const filteredData = this.filterData();
    const formattedData = this.formatData(filteredData);

    return (
      <ExpertsRatingsContainer>
        <Card>
          <CardHeader
            title={I18n.t('notes.wxr.tableTitle')}
            fontSize="20px"
            iconColor="#e25d34"
            iconRight
            rightComponents={
              <ExportButton
                name={this.getExportName() + I18n.t('notes.wxr.tableTitle')}
                path="/communication/notation/wxr/data/xls?"
                options={{
                  vintage: vintage.label,
                  type: type.label
                }}
                newApi
                xls
              />
            }
          />

          <FilterBloc
            marginBottom="20px"
            options={options}
            {...this.state}
            onChange={(field, value) => this.setState({ [field]: value })}
            onChangeType={(value) => this.handleOnChangeFilter('type', value)}
            onChangeVintage={(value) =>
              this.handleOnChangeFilter('vintage', value)
            }
          />
          <div className="tableWxrContainer">
            <Table
              data={formattedData}
              columns={columns}
              sorted={sorted}
              subRowsKey={null}
            />
          </div>
        </Card>
        <Spinner loading={this.props.loading} little />
      </ExpertsRatingsContainer>
    );
  }
}

export default withTheme(ExpertsRatings);
